export const projectsData = [
  {
    id: 1,
    image: "/assets/Work1.webp",
    title: "Mini Portfolio",
    link: "https://yash-portfolio-dev.netlify.app/",
    category: "web",
  },
  {
    id: 2,
    image: "/assets/oknoted.webp",
    title: "Ok noted",
    link: "https://oknoted.netlify.app/",
    category: "web",
  },
  {
    id: 4,
    image: "/assets/Work2.webp",
    title: "Ninjaas Assignment",
    link: "https://material-implement.netlify.app/",
    category: "design",
  },
  {
    id: 5,
    image: "/assets/Work3.webp",
    title: "Travel App",
    link: "https://travelappnext.netlify.app/",
    category: "design",
  },
  {
    id: 6,
    image: "/assets/Work4.webp",
    title: "Freelance Work",
    link: "https://naturalfirst.in/",
    category: "web",
  },
  {
    id: 7,
    image: "/assets/Work5.webp",
    title: "Movie App",
    link: "https://yash2026.github.io/movie-app/",
    category: "web",
  },
  {
    id: 8,
    image: "/assets/Work6.webp",
    title: "Weather App",
    link: "https://applocal-weather.netlify.app/",
    category: "web",
  },
  {
    id: 9,
    image: "/assets/Work7.webp",
    title: "Tax Calculator",
    link: "https://fyle-taxcalci.netlify.app/",
    category: "web",
  },
  {
    id: 10,
    image: "/assets/Work8.webp",
    title: "Ottermap WebApp",
    link: "https://ottermap-assign.netlify.app/",
    category: "web",
  },
  {
    id: 11,
    image: "/assets/Work9.webp",
    title: "NetArt Assign",
    link: "https://netart-yash.netlify.app/",
    category: "design",
  },
];

export const projectsNav = [
  {
    name: "all",
  },
  {
    name: "web",
  },
  {
    name: "design",
  },
];
